import { useEffect } from 'react';
import { RegionService } from '../../../services/regionService';
import { Outlet } from 'react-router-dom';

const MainLayout = () => {
	const regionService = new RegionService();

	useEffect(() => {
		let pathArray = window.location.pathname.split('/');
		const region = pathArray[1];
		const currentRegion = regionService.currentRegion();
		if (!region) {
			return;
		}
		if (region === currentRegion) {
			return;
		} else {
			regionService.setRegion(region);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return <Outlet />;
};

export default MainLayout;
